export default __webpack_public_path__ + "static/media/logo1.ea41effe.png";